import type { StartPayConfig } from "../types/config";
import type { PaymentStatusInput } from "../types/payment";
import type { StartPayResponse } from "../types/response";
import { buildUrl } from "../utils/buildUrl";
import { requestJson } from "../utils/request";
import { DEFAULT_ENDPOINTS } from "./constants";

export const getPaymentStatus = (config: StartPayConfig, input: PaymentStatusInput) => {
  const endpoint = config.endpoints?.paymentStatus ?? DEFAULT_ENDPOINTS.paymentStatus;

  return requestJson<StartPayResponse>(
    buildUrl(config.apiBaseUrl, endpoint, {
      orderId: input.orderId,
      paymentId: input.paymentId ?? undefined,
      paymentSessionId: input.paymentSessionId
    }),
    {
      method: "GET",
      headers: config.headers,
      timeout: config.timeout,
      signal: input.signal
    }
  );
};

export const cancelPayment = (config: StartPayConfig, input: PaymentStatusInput) => {
  const endpoint = config.endpoints?.cancelPayment ?? DEFAULT_ENDPOINTS.cancelPayment;

  return requestJson<StartPayResponse>(buildUrl(config.apiBaseUrl, endpoint), {
    body: input,
    headers: config.headers,
    timeout: config.timeout,
    signal: input.signal
  });
};
